/* Independent Starter Pack sections: retain PDP pricing and selection as the source of truth. */
(() => {
  if (window.__starterPackSections) return;
  window.__starterPackSections = true;
  const roots = () => [...document.querySelectorAll('[data-spp-extra]')];
  const owner = root => [...document.querySelectorAll('[data-spp]')].find(el => el.dataset.sppGroup === root.dataset.sppGroup);
  const text = (root, selector, value) => root.querySelectorAll(selector).forEach(el => { el.textContent = value; });
  const sync = root => {
    const main = owner(root), pdp = main && main.__spp;
    root.querySelectorAll('a[href^="#spp-"]').forEach(link => {
      if (main && !link.dataset.sppLinked) { link.href = '#' + main.id; link.dataset.sppLinked = 'true'; }
    });
    if (!pdp) return;
    const weeks = pdp.state.plan ? pdp.state.plan.weeks : pdp.cfg.defaultWeeks;
    text(root, '[data-spp-weeks-label]', weeks + ' weeks');
    root.querySelectorAll('[data-spp-week-num]').forEach(el => { el.textContent = weeks * Number(el.dataset.sppWeekNum); });
    const price = main.querySelector('[data-spp-today-price]');
    if (price && price.textContent) text(root, '[data-spp-tl-price]', price.textContent + ' · free delivery');
    ['[data-spp-summary]', '[data-spp-cta-label]'].forEach(selector => {
      const source = main.querySelector(selector);
      if (source) text(root, selector, source.textContent);
    });
    root.querySelectorAll('[data-spp-cta]').forEach(btn => { btn.disabled = pdp.state.busy; });
    root.querySelectorAll('.spp-energy__col').forEach(btn => {
      const i = pdp.coffees.findIndex(c => String(c.productId) === btn.dataset.productId);
      btn.disabled = i < 0;
      const selected = i >= 0 && (i === pdp.state.c1 || i === pdp.state.c2);
      btn.classList.toggle('is-picked', selected);
      btn.setAttribute('aria-pressed', String(selected));
    });
  };
  const initRoot = root => {
    if (root.dataset.sppBound) return;
    root.dataset.sppBound = 'true';
    const activate = (selector, clicked) => root.querySelectorAll(selector).forEach(btn => {
      const active = btn === clicked; btn.classList.toggle('is-active', active); btn.setAttribute('aria-pressed', String(active));
    });
    root.querySelectorAll('[role="tablist"]').forEach(el => { el.setAttribute('role', 'group'); });
    root.querySelectorAll('.spp-chip').forEach(btn => { btn.setAttribute('aria-pressed', String(btn.classList.contains('is-active'))); });
    root.addEventListener('click', event => {
      const btn = event.target.closest('button');
      if (!btn || !root.contains(btn)) return;
      if (btn.closest('[data-spp-review-chips]')) {
        activate('[data-spp-review-chips] .spp-chip', btn);
        root.querySelectorAll('.spp-review').forEach(card => { card.hidden = !(btn.dataset.filter === 'all' || (btn.dataset.filter === 'subscriber' ? card.dataset.subscriber === 'true' : card.dataset.strength === btn.dataset.filter)); });
      }
      if (btn.closest('[data-spp-sci-tabs]')) {
        activate('[data-spp-sci-tabs] .spp-chip', btn);
        root.querySelectorAll('.spp-sci__card').forEach(panel => { panel.classList.toggle('is-active', panel.dataset.panel === btn.dataset.tab); });
      }
      if (btn.closest('[data-spp-compare-pick]')) {
        activate('[data-spp-compare-pick] .spp-chip', btn);
        const table = root.querySelector('[data-spp-compare]'); if (table) table.dataset.activeCol = btn.dataset.col;
      }
      if (btn.matches('.spp-energy__col')) {
        const main = owner(root), pdp = main && main.__spp;
        if (pdp) { const i = pdp.coffees.findIndex(c => String(c.productId) === btn.dataset.productId); if (i >= 0) { pdp.touched = true; pdp.state.c1 = i; pdp.render(); } }
      }
      if (btn.matches('[data-spp-cta]')) { const main = owner(root), pdp = main && main.__spp; if (pdp) pdp.addToCart(); }
      if (btn.matches('[data-spp-video-play]')) {
        const wrap = btn.closest('[data-spp-video]'), tpl = wrap.querySelector('template');
        if (tpl) { const content = tpl.content.cloneNode(true); wrap.replaceChildren(content); wrap.classList.add('is-playing'); }
      }
    });
    root.querySelectorAll('[data-spp-saver]').forEach(saver => {
      const range = saver.querySelector('[data-spp-cups]');
      const calc = () => {
        const cups = Number(range.value), saving = Math.max(0, ((Number(saver.dataset.cafe) || 0) - (Number(saver.dataset.ours) || 0)) * cups * 365);
        text(saver, '[data-spp-cups-label]', cups); text(saver, '[data-spp-saving]', '£' + Math.round(saving).toLocaleString('en-GB'));
      };
      range.addEventListener('input', calc); calc();
    });
  };
  const init = () => {
    roots().forEach(initRoot);
    document.querySelectorAll('[data-spp]').forEach(main => {
      const pdp = main.__spp;
      if (pdp && !pdp.__sectionsConnected) {
        pdp.__sectionsConnected = true;
        ['render', 'setBusy', 'showError'].forEach(method => {
          const original = pdp[method];
          pdp[method] = function(...args) { const result = original.apply(this, args); roots().filter(root => owner(root) === main).forEach(sync); return result; };
        });
      }
      [['.spp-rating', 'proof'], ['.spp-step__head .spp-link', 'science']].forEach(([selector, kind]) => {
        const extra = roots().find(root => root.dataset.sppExtra === kind && owner(root) === main);
        const target = extra && extra.querySelector('section[id]');
        main.querySelectorAll(selector).forEach(link => { if(target) link.href = '#' + target.id; });
      });
    });
    roots().forEach(sync);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
